let userPrefix = '';
let getPrefixedKey = function (key: string): string {
  return userPrefix === '' ? key : `${userPrefix}-${key}`;
};

export let pdsLocalStorage = {
    // Overridden by Object.defineProperty at the end of the file
    userPrefix: '',
    /**
     * Gets an item from local storage with the specified key
     */
    getItem(key: string): string | undefined {
      return localStorage.getItem(key) || undefined;
    },

    /**
     * Gets a persisted boolean from local storage, returns defaultResult if the value doesn't exist
     */
    getPersistedBoolean: function (key: string, defaultResult = false): boolean {
      let item = this.getItem(key);
      if (item == null) {
        return defaultResult;
      }

      return item === 'true';
    },

    /**
     * Removes an item from local storage with the specified key
     */
    removeItem(key: string): void {
      localStorage.removeItem(key);
    },

    /**
     * Sets an item with the specified key to the specified value.  Returns true if localStorage is available, false if not.
     */
    setItem(key: string, value: string): boolean {
     // localStorage is not available in Safari private browsing mode so wrap setItem in a try catch block
      try {
        localStorage.setItem(key, value);
        return true;
      } catch (err) {
        console.error(`Browser local storage is not available`);
        return false;
      }
    },

    /**
     * User functions are equivelent to the non-user functions when userPrefix is empty string.
     * When userPrefix is not an empty string, user functions automatically add a prefix to the key.
     */
    getUserItem(key: string): string | undefined {
      return this.getItem(getPrefixedKey(key));
    },

    getUserPersistedBoolean (key: string, defaultResult = false): boolean {
      return this.getPersistedBoolean(getPrefixedKey(key), defaultResult);
    },

    removeUserItem(key: string): void {
      this.removeItem(getPrefixedKey(key));
    },

    setUserItem(key: string, value: string): boolean {
      return this.setItem(getPrefixedKey(key), value);
    }
  };

Object.defineProperty(pdsLocalStorage, 'userPrefix', {
  get: function(): string {
    return userPrefix;
  },
  set: function(value: string): void {
    userPrefix = value;
  }
});
